// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getProductListStatus: { data: null },
  createProductStatus: { data: null },
  getCategoriesListStatus: {data: null},
};
